query AnalyticsViewsByLink($filter: AnalyticsViewsFilterInput!, $limit: Int) {
  analyticsViews(filter: $filter) {
    viewsByLink(limit: $limit) {
      linkId
      title
      views
      visitors
    }
  }
}
